import { Text, cn } from '@kognitos/lattice';

/** The square "L1" / "L2" level tile. */
export function CatalogLevelTile({
  label,
  fill,
  size,
}: {
  label: string;
  fill: string;
  size: 'l1' | 'l2';
}) {
  return (
    <Text
      as="span"
      level="xSmall"
      weight="bold"
      aria-hidden
      className={cn(
        'flex shrink-0 items-center justify-center text-primary-foreground',
        size === 'l1' ? 'size-9 rounded-lg shadow-sm' : 'size-6 rounded',
        fill,
      )}
    >
      {label}
    </Text>
  );
}
